export enum SelectEmployeeDialogFormNamesEnum {
  LAST_NAME = 'LastName',
  FIRST_NAME = 'FirstName',
}
